import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { DividerStyle } from '@website-builder/widgets/divider/model/divider-style';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class DividerWidget extends BaseWidget<DividerStyle> {
  readonly type = BuilderElementType.Divider;
  style: DividerStyle = new DividerStyle();
  hideDivider = '';

  static normalizeInPlace(widget: DividerWidget): DividerWidget {
    const pureWidget = new DividerWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.hideDivider = widget.hideDivider ?? pureWidget.hideDivider;

    widget.style = DividerStyle.normalize(widget.style);

    return widget;
  }
}
